<template>
  <div class="chart-container">
    <Radar :data="chartData" :options="chartOptions" :width="500" :height="500"/>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Radar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Title
} from 'chart.js'

// Register chart.js components (only once in application lifecycle)
ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend, Title)

const props = defineProps({
  labels: {
    type: Array,
    required: true
  },
  scores: {
    type: Array,
    required: true
  }
})

// Chart data reacts to prop changes
const chartData = computed(() => ({
  labels: props.labels,
  datasets: [
    {
      label: 'Score',
      data: props.scores,
      backgroundColor: 'rgba(54, 162, 235, 0.2)',
      borderColor: 'rgba(54, 162, 235, 1)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(54, 162, 235, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(54, 162, 235, 1)'
    }
  ]
}))

// Localized German labels around the radar (Raumaufteilung, Funktionalität,
// Zugänglichkeit, …) collide and clip at the default 16 px on phones. Scale
// the label font with the chart's actual rendered width.
const pointLabelFont = (ctx) => {
  const width = ctx.chart?.width ?? 500
  if (width < 320) return { size: 10 }
  if (width < 420) return { size: 11 }
  if (width < 600) return { size: 13 }
  return { size: 16 }
}

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    r: {
      beginAtZero: true,
      min: 0,
      max: 5,
      ticks: {
        stepSize: 1
      },
      pointLabels: {
        font: pointLabelFont,
        padding: 4
      }
    }
  },
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      callbacks: {
        label: (context) => `${context.parsed.r}`
      }
    }
  }
}
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 280px;
  min-height: 320px;
  flex: 1;
}
.chart-container canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>
